<div #clockBar class="clock-bar position-relative d-flex align-items-center py-1 border-bottom border-secondary-subtle bg-body-tertiary">
  <span class="clock-bar-local position-absolute start-0 ps-3">
    <span class="clock-zone clock-zone-local" style="cursor:default;" [ngbTooltip]="showTooltips ? 'Your local timezone' : null" placement="bottom-left" tooltipClass="custom-tooltip-success custom-tooltip-success-nowrap">
      <span class="clock-label">Local</span>
      <span class="clock-time">{{ ticks['local']?.time }}</span>
    </span>
  </span>
  <span class="clock-bar-zones mx-auto d-flex align-items-center">
    @for (zone of zones; track zone.key; let isLast = $last) {
      <span class="clock-zone" style="cursor:default;" [ngbTooltip]="showTooltips ? zone.tipTitle : null" placement="bottom" tooltipClass="custom-tooltip-success custom-tooltip-success-nowrap">
        <span class="clock-label">{{ ticks[zone.key]?.label }}</span><span class="clock-time">{{ ticks[zone.key]?.time }}</span>
      </span>
      @if (!isLast) {
        <span class="clock-sep"></span>
      }
    }
  </span>
  @if (showCloseButton) {
    <button
      class="clock-bar-close position-absolute end-0 me-2 btn-close btn-close-sm"
      [ngbTooltip]="showTooltips ? 'Hide clock bar' : null"
      placement="left"
      tooltipClass="custom-tooltip-success"
      type="button"
      (click)="closeClicked()"
    >
    </button>
  }
</div>
